import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('one_event_improvements_1');
	},
};
